import React from "react";
import { VStack } from "@chakra-ui/react";
import { Checkbox } from "components";
import { StoredDisclaimerProcedure } from "duck";
import { Actions } from "./components";
import { ProceduresType, SelectionContext } from "./duck";

interface ProceduresProps {
  procedures: ProceduresType;
  organizationSettingId: number;
}

const Procedures: React.FC<ProceduresProps> = ({
  procedures,
  organizationSettingId
}) => {
  const [selected, setSelected] = React.useState<StoredDisclaimerProcedure[]>(
    []
  );

  return (
    <SelectionContext.Provider
      value={{
        selected,
        select: proc => setSelected(proc),
        organizationSettingId
      }}
    >
      <VStack align="left" spacing={4}>
        <Actions />
        <VStack spacing={6}>
          {procedures.map(procedure => {
            const isChecked = selected.some(proc => proc._id === procedure._id);
            return (
              <Checkbox
                key={procedure._id}
                label={`${procedure.title} — ${procedure.description}`}
                isChecked={isChecked}
                onChange={() => {
                  const newSelected = isChecked
                    ? selected.filter(proc => proc._id !== procedure._id)
                    : [...selected, procedure];
                  setSelected(newSelected);
                }}
              />
            );
          })}
        </VStack>
      </VStack>
    </SelectionContext.Provider>
  );
};

export default Procedures;
